'use strict';

import usePhoneMask from '../hooks/usePhoneMask';

export default function PhoneInput ( {
    label = "",
    value: userValue,
    phoneCode,
    error = null,
    disabled = false,
    autoFocus = false,
    readOnly = false,
    className,
    inputClassName = "",
    onChange,
    onCompleteChange,
    onCodeChange,
    showFlagSelect = true,
} )
{
    const inputRef = React.useRef ();

    const [ id ] = React.useState ( () => `FormInput_phone_${ _.uniqueId () }` );

    const [ maskedValue, value, updateValue, currentCountry, updateCountry, isComplete ] = usePhoneMask (
        userValue,
        onChange,
        phoneCode,
        country => onCodeChange ( country ? country.code : '' )
    );
    const flagCode = React.useMemo ( () => currentCountry ? currentCountry.code.toLowerCase () : 'gj', [ currentCountry ] );

    React.useEffect ( () =>
    {
        if ( !phoneCode && currentCountry && value.length === 0 )
        {
            updateValue ( currentCountry.phone );
        }
    }, [ currentCountry ] );

    React.useEffect ( () =>
    {
        onCompleteChange && onCompleteChange ( isComplete );
    }, [ isComplete ] );

    const handleFlagClick = () =>
    {
        $.fancybox.open ( {
            src: '#reactFlagSelectModal',
            props: {
                onSelect: country =>
                {
                    updateCountry ( country.code );
                    inputRef.current.focus ();
                },
            }
        } );
    };

    const handleInput = React.useCallback ( ( e ) =>
    {
        updateValue ( e.target.value );
    }, [ updateValue ] );

    return (
        <div className={ clsx ( 'inputbox', className, 'phone-inputbox', {
            changed: value,
            'error-filed': error
        } ) }>
            {label && <label htmlFor={ id }>{ label }</label>}
            <div className="phone-code__wrap">
                {showFlagSelect && <div className="flag-select" onClick={readOnly ? null : handleFlagClick}>
                    <img src={`${themeDir}/images/flags/${flagCode}.svg`} alt=""/>
                </div>}
                <input
                    id={ id }
                    ref={ inputRef }
                    type="text"
                    value={ maskedValue }
                    readOnly={ readOnly }
                    disabled={ disabled }
                    autoComplete={ 'off' }
                    inputMode="tel"
                    onInput={ handleInput }
                    autoFocus={ autoFocus }
                    className={inputClassName}
                />
            </div>

            { !!error && <div className="error-message">
                { error }
            </div> }
        </div>
    );
}
